export const POSTHOG_EVENTS = {
  NEW_CHAT_MESSAGE: 'new_chat_message',
  NEW_CHAT_CREATED: 'new_chat_created'
} as const

export type PostHogEvent = keyof typeof POSTHOG_EVENTS
